import React from 'react';

// Class-specific form fields configuration
const classFields = {
  Class_1: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Medical Device'], required: true, section: 'Assets' },
    { name: 'productDescription', label: 'Product Description', type: 'textarea', required: true, section: 'Assets' },
    
    // Plans
    { name: 'reference501k', label: '501k - Reference Product of Equivalence', type: 'textarea', required: false, section: 'Plans' },
    { name: 'demonstration501k', label: '501k - Demonstration of Substantial Equivalence', type: 'textarea', required: false, section: 'Plans' },
    { name: 'expectedLabeling', label: 'Expected Labeling', type: 'textarea', required: false, section: 'Plans' },
    { name: 'submissionDate', label: 'eSTAR / ESG Submission Planned Date', type: 'date', required: false, section: 'Plans' }
  ],
  
  Class_2: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Medical Device'], required: true, section: 'Assets' },
    { name: 'productDescription', label: 'Product Description', type: 'textarea', required: true, section: 'Assets' },
    
    // Plans
    { name: 'reference501k', label: '501k - Reference Product of Equivalence', type: 'textarea', required: false, section: 'Plans' },
    { name: 'demonstration501k', label: '501k - Demonstration of Substantial Equivalence', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoBenchTest', label: 'De Novo - Non-Clinical - Bench Test', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoBiocompatibility', label: 'De Novo - Non-Clinical - Biocompatibility', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoEMC', label: 'De Novo - Non-Clinical - Electromagnetic Compatibility', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoSterilization', label: 'De Novo - Non-Clinical - Sterilization Validation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoShelfLife', label: 'De Novo - Non-Clinical - Shelf life validation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoHumanFactors', label: 'De Novo - Non-Clinical - Human Factors and Usability Studies', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoSoftware', label: 'De Novo - Non-Clinical - Software Documentation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoClinicalProtocol', label: 'De Novo - Clinical - Clinical Study Protocol', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoClinicalResults', label: 'De Novo - Clinical - Clinical Study Target Results', type: 'textarea', required: false, section: 'Plans' },
    { name: 'deNovoInvestigator', label: 'De Novo - Clinical - Investigator Information', type: 'textarea', required: false, section: 'Plans' },
    { name: 'expectedLabeling', label: 'Expected Labeling', type: 'textarea', required: false, section: 'Plans' },
    { name: 'submissionDate', label: 'eSTAR / ESG Submission Planned Date', type: 'date', required: false, section: 'Plans' }
  ],
  
  Class_3: [
    // Assets
    { name: 'productCategory', label: 'Product Category', type: 'select', options: ['Medical Device'], required: true, section: 'Assets' },
    { name: 'productDescription', label: 'Product Description', type: 'textarea', required: true, section: 'Assets' },
    
    // Plans
    { name: 'nonClinicalBenchTest', label: 'Non-Clinical - Bench Test', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalBiocompatibility', label: 'Non-Clinical - Biocompatibility', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalEMC', label: 'Non-Clinical - Electromagnetic Compatibility', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalSterilization', label: 'Non-Clinical - Sterilization Validation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalShelfLife', label: 'Non-Clinical - Shelf life validation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalHumanFactors', label: 'Non-Clinical - Human Factors and Usability Studies', type: 'textarea', required: false, section: 'Plans' },
    { name: 'nonClinicalSoftware', label: 'Non-Clinical - Software Documentation', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalProtocol', label: 'Clinical - Clinical Study Protocol', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalResults', label: 'Clinical - Clinical Study Target Results', type: 'textarea', required: false, section: 'Plans' },
    { name: 'clinicalInvestigator', label: 'Clinical - Investigator Information', type: 'textarea', required: false, section: 'Plans' },
    { name: 'expectedLabeling', label: 'Expected Labeling', type: 'textarea', required: false, section: 'Plans' },
    { name: 'submissionDate', label: 'eSTAR / ESG Submission Planned Date', type: 'date', required: false, section: 'Plans' }
  ]
};

const ClassInputForm = ({ deviceClass, formData, setFormData }) => {
  const fields = classFields[deviceClass] || [];
  
  // Group fields by section
  const assetFields = fields.filter(field => field.section === 'Assets');
  const planFields = fields.filter(field => field.section === 'Plans');

  const handleChange = (fieldName, value) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const renderField = (field) => {
    switch (field.type) {
      case 'textarea':
        return (
          <textarea
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            rows="4"
            required={field.required}
          />
        );
      case 'select':
        return (
          <select
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            required={field.required}
          >
            <option value="">Select an option</option>
            {field.options.map(option => (
              <option key={option} value={option}>{option}</option>
            ))}
          </select>
        );
      case 'date':
        return (
          <input
            type="date"
            id={field.name}
            value={formData[field.name] || ''}
            onChange={(e) => handleChange(field.name, e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500"
            required={field.required}
          />
        );
      default:
        return null;
    }
  };

  const renderSection = (title, sectionFields) => {
    if (sectionFields.length === 0) return null;
    
    return (
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">{title}</h2>
        <div className="space-y-4">
          {sectionFields.map(field => (
            <div key={field.name} className="mb-4">
              <label htmlFor={field.name} className="block text-gray-700 text-sm font-bold mb-2">
                {field.label}{field.required && <span className="text-red-500">*</span>}
              </label>
              {renderField(field)}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="space-y-6">
      {renderSection('Assets', assetFields)}
      {renderSection('Plans', planFields)}
    </div>
  );
};

export default ClassInputForm; 